// Cache global para autenticação
let authCache: {
  isAuthenticated: boolean | null;
  user: any | null;
  lastCheck: number;
  isChecking: boolean;
} = {
  isAuthenticated: null,
  user: null,
  lastCheck: 0,
  isChecking: false
};

const CACHE_DURATION = 30000; // 30 segundos

export const getAuthCache = () => authCache;

export const setAuthCache = (isAuthenticated: boolean, user: any = null) => {
  authCache = {
    isAuthenticated,
    user,
    lastCheck: Date.now(),
    isChecking: false
  };
};

export const isAuthCacheValid = () => {
  return Date.now() - authCache.lastCheck < CACHE_DURATION;
};

export const setChecking = (checking: boolean) => {
  authCache.isChecking = checking;
};

export const clearAuthCache = () => {
  authCache = {
    isAuthenticated: null,
    user: null,
    lastCheck: 0,
    isChecking: false
  };
};